import TimeStamp from "../../../../components/TimeStamp/component";
import AuthorImage from "../../../../components/AuthorImage/component";
import { AuthorList } from "../AuthorList/component";
import Bullet from "../Bullet/component";
import {
    getUserTimeZone,
    unixToZonedBylineDate,
} from "../../../../utils/dateTime/library";
import useSSR from "../../../../hooks/useSSR";
import { BIO_AND_PHOTO, PHOTO } from "../../../../utils/author/constants";
import { withSuspensefulErrorBoundary } from "../../../../components/SuspensefulErrorBoundary/component";

const Byline = ({
    updatedAt = 0,
    publishedAt = 0,
    text = "",
    authorDisplay = "",
    authorList = [],
    publishedAtVerbal = "",
}) => {
    const isSSR = useSSR();
    const getByline = () => {
        if (!text) return null;

        return (
            <>
                {text} <Bullet />
            </>
        );
    };

    const getAuthorImage = () => {
        const showAuthorImage = [BIO_AND_PHOTO, PHOTO].includes(authorDisplay);

        const authorImage = authorList[0]?.photoURL
            ? `${authorList[0].photoURL}Resize%3D114`
            : "";

        return showAuthorImage && authorImage ? (
            <AuthorImage src={authorImage} />
        ) : null;
    };

    const getTimeStamp = () => {
        let verbal = publishedAtVerbal;
        const userTimezone = getUserTimeZone();
        if (!isSSR && publishedAt && userTimezone) {
            const updatedTimezoneString = unixToZonedBylineDate(
                publishedAt,
                userTimezone
            );

            if (updatedTimezoneString) {
                verbal = updatedTimezoneString;
            }
        }

        return <TimeStamp updated={updatedAt} publishedAtVerbal={verbal} />;
    };

    const getAuthorText = () => {
        if (!authorList.length) return null;

        return (
            <>
                <AuthorList authorList={authorList} /> <Bullet />
            </>
        );
    };

    const authorText = getAuthorText();
    const byline = getByline();
    const timestamp = getTimeStamp();

    if (authorText || byline || timestamp) {
        return (
            <div className="byline" data-testid="byline">
                {getAuthorImage()}
                <div className="bylineDetails">
                    {authorText}
                    {byline}
                    {timestamp}
                </div>
            </div>
        );
    }

    return null;
};

const SafeByline = withSuspensefulErrorBoundary(Byline);

export default SafeByline;
